import './App.css';
import MiniDrawer from './pages/drawer/Drawer';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {
  return (
    <div className="App">
    <Router>
      <ThemeProvider theme={darkTheme}>
        <MiniDrawer />
      </ThemeProvider>
    </Router>
    </div>
  );
}

export default App;
